import React, { useState, useCallback, useEffect } from "react";
import CardProject from "../components/CardProject";
import VideoSlider from "../components/VideoSlider";
import CardWorkflow from "../components/CardWorkflow";
import excelFile from "../../src/data.xlsx";
import ReadExcel from "../components/utils/ReadExcel";

export default function Film() {
  useEffect(() => {
    document.title = "Filmprojekte - Erik Schott";
  }, []);

  const slides = [
    { title: "Showevent", type: "video", videoUrl: "https://youtu.be/fNahO65qCZc?feature=shared", videoThumbnail: "https://img.youtube.com/vi/fNahO65qCZc/maxresdefault.jpg" },
    { title: "Image", type: "video", videoUrl: "https://youtu.be/csljqVPF07I", videoThumbnail: "https://img.youtube.com/vi/csljqVPF07I/maxresdefault.jpg" },
    { title: "Livestream", type: "video", videoUrl: "https://www.youtube.com/live/pjtykQGNhoI?si=qO0LUjpm2Gcdgld6", videoThumbnail: "https://img.youtube.com/vi/pjtykQGNhoI/maxresdefault.jpg" },
    { title: "Veranstaltungen", type: "video", videoUrl: "https://youtu.be/woX7Aqecvvw", videoThumbnail: "https://img.youtube.com/vi/woX7Aqecvvw/maxresdefault.jpg" },
    { title: "Podcast", type: "video", videoUrl: "https://youtu.be/f-aYnjiDz5o", videoThumbnail: "https://img.youtube.com/vi/f-aYnjiDz5o/maxresdefault.jpg" }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [excelData, setExcelData] = useState({ ProjekteFilm: [], WorkflowFilm: [] });

  const handleDataLoad = useCallback((data) => {
    setExcelData(data);
  }, []);

  const goToPrevious = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1));
  }, [slides.length]);

  const goToNext = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
  }, [slides.length]);

  return (
    <>
      <ReadExcel filePath={excelFile} onDataLoad={handleDataLoad} />
      <div className="page-wrapper">
        <div className="max-wrapper">
          <div className="content-head">
            <h1 className="h1">Filmografie</h1>
            <VideoSlider slides={slides} currentIndex={currentIndex} goToPrevious={goToPrevious} goToNext={goToNext} />
          </div>
        </div>
        <div className="content-wrapper">
          <div className="content-head">
            <h2 className="h1">Projekte</h2>
            <h3 className="h4">Ausgesuchte Arbeiten</h3>
          </div>
          <div className="thumbnail-wrapper">
            {excelData.ProjekteFilm?.filter((card) => card.key?.toLowerCase() === slides[currentIndex].title.toLowerCase()).map((card) => (
              <CardProject key={card.titel} titel={card.titel} rolle={card.rolle} image={card.image} link={card.link} type={card.type}/>
            ))}
          </div>
        </div>
        <div className="content-wrapper">
          <div className="content-head">
            <h2 className="h1">Workflow</h2>
            <h3 className="h4">So arbeiten wir zusammen</h3>
          </div>
          <div className="card-wrapper">
            {excelData.WorkflowFilm?.map((card) => (
              <CardWorkflow key={card.titel} titel={card.titel} image={card.image} beschreibung={card.beschreibung} nummer={card.nummer} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}